import styled from "styled-components";

export const MiniCardContainer = styled.div`
  border-radius: 16px;
  border: 1px solid #ececec;
  padding: 28px 24px 24px 24px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  background-color: #E8E8EA3D;
  border-color: var(--color-gray-200);
`;

export const IconCircle = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
`;

export const MiniCardTitle = styled.h3`
  font-size: 1.15rem;
  font-weight: 700;
  color: #232336;
  margin: 0;
`;

export const MiniCardDescription = styled.p`
  font-size: 1rem;
  color: #8c8c8c;
  margin: 0;
`;

export const MiniCardButton = styled.a`
  margin-top: 8px;
  padding: 6px 20px;
  background: var(--color-purple);
  color: #fff;
  border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  text-decoration: none;
  transition: background 0.2s;
  &:hover {
    background: var(--color-purple-600);
  }
  width: 100%;
  text-align: center;
`;